import React, { useEffect, useState } from "react";
import { store } from "../../redux/oldStore.tsx";
import NhdNav from "../Layout/NhdNav";

/**
 * Port of /Start — Quick Start Guide for NHD affiliate admins.
 */
export default function Start() {
  const [user, setUser] = useState(null);

  const loadUser = () => {
    store.server.getApi("Contests/List").then((r) => {
      if (r && r.Success && r.Value) {
        setUser(r.Value.user || null);
      }
    });
  };

  useEffect(() => {
    loadUser();
  }, []);

  return (
    <div className="nhd-page start-page">
      <NhdNav user={user} onAuthChange={loadUser} />
      <div className="nhd-page-body start-body">
        <h1 id="list">National History Day - Getting Started</h1>
        <ul className="start-toc">
          <li>
            <a href="#loginfirsttime">First Time Logging-In</a>
          </li>
          <li>
            <a href="#SetSchedule">Set Schedule &amp; Important Dates</a>
          </li>
          <li>
            <a href="#Custimze">Customize Your Site</a>
          </li>
          <li>
            <a href="#ChangeRole">Change Role</a>
          </li>
          <li>
            <a href="#ViewEditAdult">
              View / Edit Teacher, Judge, Volunteer, and staff Information
            </a>
          </li>
          <li>
            <a href="#ViewEditStudent">View / Edit Student Information</a>
          </li>
          <li>
            <a href="#LinkProjects">Link or Combine two student entries</a>
          </li>
        </ul>

        <section id="loginfirsttime">
          <h2>Logging in for the first time</h2>
          <a href="#list">top</a>
          <ol>
            <li>Find your contest</li>
            <li>To Sign-In</li>
            <li>
              Click on <strong>Login</strong> located on the top right.
            </li>
            <li>
              Click on <strong>forgot password/username</strong>
            </li>
            <li>
              Fill out the form and click{" "}
              <strong>Recover Username &amp; Password</strong>
            </li>
            <li>
              The system should send you an email that will allow you to
              sign-in.
            </li>
            <li>
              The system will tell you if it sends you an email or not. If you
              were sent an email click on the link in the email to change your
              password. Now you can sign-in.
            </li>
            <li>
              If the system cannot find you make sure you spelled your name and
              email exactly how it was entered into the google sheet.
            </li>
            <li>
              If the system still cannot find you please register as a volunteer
              and have your affiliate create a ticket at{" "}
              <a
                href="https://ticket.nhd.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                ticket.nhd.org
              </a>{" "}
              to have your account made into an admin.
            </li>
          </ol>
          <p>
            Do not share your username/password with others. If you have other
            staff members please have them register as a volunteer and you can
            then promote them to be a staff member or admin.{" "}
            <a href="#ChangeRole">Change Role</a>
          </p>
        </section>

        <section id="SetSchedule">
          <h2>Set Schedule &amp; Important Dates</h2>
          <a href="#list">top</a>
          <ol>
            <li>Sign-In</li>
            <li>
              Click on <strong>Staff Tools → Contest Setup</strong> located in
              the menu.
            </li>
            <li>
              Click on <strong>Schedule</strong> tile
            </li>
            <li>Specify your Timezone and Schedule</li>
            <li>
              Click <strong>Save</strong>
            </li>
          </ol>
        </section>

        <section id="Custimze">
          <h2>Customize your Site</h2>
          <a href="#list">top</a>
          <p>
            <a
              href="https://youtu.be/IUwjtrLD3ro"
              target="_blank"
              rel="noopener noreferrer"
            >
              Customize your Site Video
            </a>
          </p>
          <ol>
            <li>Sign-In</li>
            <li>
              Click on <strong>Edit</strong> located in the menu.
            </li>
            <li>Double Click on anything that has the edit background</li>
            <li>
              Make your changes and click <strong>Save</strong>
            </li>
          </ol>
          <h3>Or</h3>
          <ol>
            <li>Sign-In</li>
            <li>
              Click on <strong>Staff Tools → Contest Setup</strong> located in
              the menu.
            </li>
            <li>
              Click on <strong>Customize</strong>
            </li>
            <li>Click on the page you want to change</li>
            <li>
              Make your changes and click <strong>Save</strong>
            </li>
          </ol>
        </section>

        <section id="ChangeRole">
          <h2>Change Users Role</h2>
          <a href="#list">top</a>
          <p>
            Promote/demote a user to a new role such as volunteer, judge,
            teacher, staff, or admin.
          </p>
          <ol>
            <li>Sign-In</li>
            <li>
              Click on <strong>Staff Tools → Directory</strong> located in the
              menu.
            </li>
            <li>Click on the edit pen for the person you want.</li>
            <li>Set new role.</li>
            <li>
              Click <strong>Change Role</strong>.
            </li>
          </ol>
        </section>

        <section id="ViewEditStudent">
          <h2>View / Edit Student Information</h2>
          <a href="#list">top</a>
          <p>
            <a
              href="https://youtu.be/VRx32M7VhMA"
              target="_blank"
              rel="noopener noreferrer"
            >
              Viewing &amp; Managing User Information Video
            </a>
          </p>
          <ol>
            <li>Sign-In</li>
            <li>
              Click on <strong>Students</strong> located in the menu.
            </li>
            <li>Click on the student you want to view/edit.</li>
          </ol>
        </section>

        <section id="ViewEditAdult">
          <h2>View / Edit Teachers, Judges, Volunteers, &amp; Staff</h2>
          <a href="#list">top</a>
          <p>
            <a
              href="https://youtu.be/VRx32M7VhMA"
              target="_blank"
              rel="noopener noreferrer"
            >
              Viewing &amp; Managing User Information Video
            </a>
          </p>
          <ol>
            <li>Sign-In</li>
            <li>
              Click on <strong>Staff Tools → Directory</strong> located in the
              menu.
            </li>
            <li>Click on the edit pen for the person you want to view/edit.</li>
          </ol>
        </section>

        <section id="LinkProjects">
          <h2>Link or Combine two student entries</h2>
          <a href="#list">top</a>
          <p>
            <a
              href="https://youtu.be/ILHBGrlP2Tg"
              target="_blank"
              rel="noopener noreferrer"
            >
              Link or Combine two student entries
            </a>
          </p>
          <ol>
            <li>Sign-In</li>
            <li>
              Click on <strong>Students</strong> located in the menu.
            </li>
            <li>Select the student whose project you want to keep</li>
            <li>
              Click <strong>Edit / View Participant</strong>
            </li>
            <li>
              Copy the <strong>Project Key</strong>
            </li>
            <li>Close the open project</li>
            <li>
              Select the student who you want to join the project whose key you
              copied.
            </li>
            <li>
              Click <strong>Link to a project</strong>
            </li>
            <li>
              Enter project key into the <strong>Team Key / Entry Id</strong>{" "}
              slot
            </li>
            <li>
              Click <strong>Link Project</strong>
            </li>
          </ol>
        </section>
      </div>
    </div>
  );
}
